import { useNavigate } from "@tanstack/react-router";
import { toast } from "sonner";
import { StoreForm } from "@/components/stores/store-form";
import { useCreateStore } from "@/hooks/use-stores";
import { useActiveStore } from "@/hooks/use-active-store";

export function NewStorePage() {
  const navigate = useNavigate();
  const createStore = useCreateStore();
  const { setStoreId } = useActiveStore();

  async function handleSubmit(values: {
    name: string;
    url: string;
    consumerKey: string;
    consumerSecret: string;
  }) {
    try {
      const store = await createStore.mutateAsync(values);
      if (store?.id) {
        setStoreId(store.id);
      }
      toast.success("Trgovina dodana");
      navigate({ to: "/settings" });
    } catch (e: any) {
      toast.error(e.message || "Greška pri dodavanju trgovine");
    }
  }

  return (
    <div className="p-4 flex flex-col gap-3">
      <h2 className="text-sm font-medium">Nova trgovina</h2>
      <div className="max-w-lg">
        <StoreForm
          onSubmit={handleSubmit}
          loading={createStore.isPending}
          submitLabel="Dodaj trgovinu"
        />
      </div>
    </div>
  );
}
